import { P2GBox } from '@parcel2go/core-ui';
import styles from './animated.module.css';

interface AppCardProps {
  children?: React.ReactNode;
  active: boolean;
}

export const AnimatedAppCard = ({ children, active }: AppCardProps) => {
  return (
    <P2GBox classNames={[styles.aiborder, active ? styles.active : '']}>
      <P2GBox classNames={[styles.inner]}>{children}</P2GBox>
    </P2GBox>
  );
};
